import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect map, direction reversed by #728 (was the real page; `../domains.tsx`
// is now the real Settings > Domains page and this is the legacy alias — see
// `goodsender-autopilot/specs/728-dashboard-nav-reorg/DECISIONS.md` D-728-4).
// Domains moved off Developer's nested children entirely. The destination has
// since become the workspace's single domain card: one domain authenticating
// email and optionally serving the blog, rather than the pool of sending
// domains plus a separate publication domain this alias once pointed at.
export const Route = createFileRoute(
  "/dashboard/w/$workspaceId/sending/domains",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/domains",
      params: { workspaceId: params.workspaceId },
    });
  },
});
